export const names = {
  TOKEN: 'token',
  LANG: 'lang',
};
